import { breakpoints } from "@brightagency/headstart-common";
import styled, { css } from "styled-components";
import { colors } from "../../../utils/colors";

export const Actions = styled.div`
    display: flex;
    gap: 24px;
`;

export const Action = styled.div<{ highlight?: boolean }>`
    display: flex;
    align-items: center;
    color: white;
    font-size: 16px;
    font-weight: 500;
    gap: 4px;

    ${breakpoints.medium} {
        font-size: 14px;
    }

    a {
        color: white;
        text-decoration: none;

        &:hover {
            text-decoration: underline;
            cursor: pointer;
        }
    }

    ${({ highlight }) =>
        highlight &&
        css`
            > *:first-child {
                color: ${colors.brandLight};
            }
            a {
                color: ${colors.brandLight};
            }
        `}
`;
